import { render, staticRenderFns } from "./LoanTransactions.vue?vue&type=template&id=74efcd9c&scoped=true&"
import script from "./LoanTransactions.vue?vue&type=script&lang=ts&"
export * from "./LoanTransactions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74efcd9c",
  null
  
)

export default component.exports